import React from "react";
import styled from "styled-components";
import TextView from "../../../TextView";
import Button from "../../../Button";
import { Close } from "@mui/icons-material";
import {colors } from "../../../../utils";
import { ASSETS } from "../../../../utils/config";
import { IconButton } from "@mui/material";

const SuggestionContainer = styled.div`
  padding: 16px;
  gap: 16px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  margin-top: 20px;
`;

const ColorsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`;

const ColorCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
`;

const ColorPreview = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr;
  gap: 10px;
`;

const ColorCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  border: 1px solid ${colors.lightGrey};
`;

const ColorCode = styled.div`
  border: 1px solid ${colors.lightBorder};
  height: 30px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  border-radius: 8px;
`;

const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 60px 160px;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 10px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const IconWrapper = styled.img`
  margin-right: 10px;
`;

export default function SuggestionPrompt({ suggestedColor, onClose, applySuggestedColor, handleIgnoreSuggestion }) {
  const { seed, adjusted } = suggestedColor;

  return (
    <SuggestionContainer>
      <Header>
        <TextView variant="subtitle" style={{ fontWeight: 600 }}>
          <IconWrapper src={ASSETS.SuggestionIcon} />
          Suggestion
        </TextView>
        <IconButton onClick={onClose}>
        <Close />
        </IconButton>
      </Header>

      <TextView>
        The segment color doesn’t match the selected mood. Here’s a tone of the same color that fits better.
      </TextView>

      <ColorsContainer>
        <ColorCard>
          <TextView variant="largeText" style={{ fontWeight: 500 }}>
            Current
          </TextView>
          <ColorPreview>
            <ColorCircle color={seed} />
            <ColorCode>
              <TextView>{seed}</TextView>
            </ColorCode>
          </ColorPreview>
        </ColorCard>

        <ColorCard>
          <TextView variant="largeText" style={{ fontWeight: 500 }}>
            Suggested
          </TextView>
          <ColorPreview>
            <ColorCircle color={adjusted} />
            <ColorCode>
              <TextView>{adjusted}</TextView>
            </ColorCode>
          </ColorPreview>
        </ColorCard>
      </ColorsContainer>

      <ButtonsContainer>
        <Button variant="secondary" onClick={handleIgnoreSuggestion}>Ignore</Button>
        <Button onClick={applySuggestedColor}>Apply & Proceed</Button>
      </ButtonsContainer>
    </SuggestionContainer>
  );
}